// LiveStreamCountDown.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { ModalId, ButtonId } from '../resource/mixpanel.js';
import { PRESET_SD } from '../resource/liveStreamConstants.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { getEncodedTemplateId } from '../resource/oembedUtils.js';
import { LIVESTREAM_PROMOTION_POPUP_ID } from '../resource/popupNotificationConstants.js';

import DiamondIconSrc from '../../img/ic-diamond-sm.svg';
import LoadingImage from '../../img/loading.png';

import Spinning from '../style/Spinning.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import TextEllipsis from '../style/TextEllipsis.js';
import media from '../style/media.js';
import { color } from '../style/variables.js';

export class LiveStreamCountDown extends React.PureComponent {
  promotionPopupTimer = null;
  getCurrentLiveStreamData = () => {
    const {
      streamId,
      mixpanelModalId,
      shouldShowPrice,
      price,
      priceDurationMinutes,
      hasBalance,
      hasStreamToken,
      isPrivateStreamUnlocked,
      isPrivateLiveStreamStarted,
      isScheduledPrivateLiveStream,
      privateLiveStreamStartTimestamp,
      shouldShowLoadingOnUnlockButton,
    } = this.props;
    return {
      modalId: mixpanelModalId,
      'stream.id': streamId,
      'liveStream.shouldShowPrice': shouldShowPrice,
      'liveStream.price': price,
      'liveStream.priceDurationMinutes': priceDurationMinutes,
      'liveStream.hasBalance': hasBalance,
      'liveStream.hasStreamToken': hasStreamToken,
      'liveStream.isPrivateStreamUnlocked': isPrivateStreamUnlocked,
      'liveStream.isPrivateLiveStreamStarted': isPrivateLiveStreamStarted,
      'liveStream.isScheduledPrivateLiveStream': isScheduledPrivateLiveStream,
      'liveStream.privateLiveStreamStartTimestamp':
        privateLiveStreamStartTimestamp,
      'liveStream.shouldShowLoadingUnlockButton':
        shouldShowLoadingOnUnlockButton,
    };
  };
  getNeedToAddvalue = () => {
    const { balance, price, priceDurationMinutes, hasBalance } = this.props;
    if (hasBalance) {
      const avaliableMins =
        Math.floor((balance / price) * priceDurationMinutes) || 0;
      return avaliableMins < priceDurationMinutes;
    }
    return false;
  };
  handleUnlockOnClick = async event => {
    const {
      streamId,
      shouldShowLoadingOnUnlockButton,
      addvalue,
      unlockPrivateStream,
      pushToastr,
    } = this.props;
    event.preventDefault();
    if (shouldShowLoadingOnUnlockButton) return;
    if (this.getNeedToAddvalue()) {
      pushToastr({
        textKey: 'alert_insufficient_funds',
        color: 'error',
      });
      return addvalue({ via: 'insufficient' });
    }
    return unlockPrivateStream({ streamId, shouldCheckDrm: true });
  };
  handleLivestreamPromotionPopup = () => {
    const {
      addPopupNotification,
      popupNotificationLiveStreamPromotionTemplateId,
      freeToPrivateLiveStreamPackagePopupThresholdSeconds,
      livestreamStartTime,
    } = this.props;

    clearTimeout(this.promotionPopupTimer);

    this.promotionPopupTimer = setTimeout(
      () => {
        addPopupNotification({
          id: LIVESTREAM_PROMOTION_POPUP_ID,
          position: 'bottom',
          link: `?campaign-id=checkout-diamondpack&campaign=&t=${getEncodedTemplateId(
            {
              templateId: popupNotificationLiveStreamPromotionTemplateId,
            }
          )}`,
          tag: LIVESTREAM_PROMOTION_POPUP_ID,
          isNotificationCenter: false,
        });
      },
      Math.max(
        0,
        freeToPrivateLiveStreamPackagePopupThresholdSeconds * 1000 -
          (Date.now() - livestreamStartTime)
      )
    );
  };
  renderUnlockButtonPaymentInfo = () => {
    const {
      t,
      price,
      priceDurationMinutes,
      productId,
      shouldShowPrice,
      isOnLivestreamOverlayCta,
    } = this.props;
    if (productId || !price || isOnLivestreamOverlayCta) {
      return null;
    }
    return (
      <UnlockLiveStreamInfo>
        <DiamondIcon src={DiamondIconSrc} width="20" height="20" />
        {shouldShowPrice ? (
          <UnlockCost>{price}</UnlockCost>
        ) : (
          <UnlockCostLoader src={LoadingImage} />
        )}
        <UnlockCostUnit>
          {t('private_stream_per_second', {
            second: priceDurationMinutes * 60,
            ns: TranslationNamespace.LIVESTREAM,
          })}
        </UnlockCostUnit>
      </UnlockLiveStreamInfo>
    );
  };
  renderUnlockButton = () => {
    const {
      productId,
      t,
      isOnLivestreamOverlayCta,
      isPrivateLiveStreamStarted,
      isAuthed,
      shouldShowLoadingOnUnlockButton,
      login,
      addvalue,
      needAuthHandler,
      fundingId,
      streamStatus,
    } = this.props;

    if (!isAuthed) {
      return (
        <UnlockWrapper>
          <UnlockLiveStreamButton
            data-element_id={
              PRESET_SD === streamStatus
                ? fundingId
                  ? ButtonId.LiveStream.ButtonShowDetailSignup
                  : ButtonId.Detail.ButtonDetailSignup
                : ButtonId.Detail.ButtonFreeDetailSignup
            }
            data-tracking_payload={this.getCurrentLiveStreamData()}
            isFilled
            onClick={() => {
              const handler = needAuthHandler === 'shop' ? addvalue : login;
              return handler();
            }}
          >
            <UnlockWording>
              {t('guest_livestream_detail_unlock', {
                ns: TranslationNamespace.LIVESTREAM,
              })}
            </UnlockWording>
          </UnlockLiveStreamButton>
        </UnlockWrapper>
      );
    }

    let buttonContent = null;
    if (productId) {
      buttonContent = t('campaign_buy_livestream_package', {
        ns: TranslationNamespace.LIVESTREAM,
      });
    } else if (this.getNeedToAddvalue()) {
      buttonContent = t('button_add_funds_for_stream', {
        ns: TranslationNamespace.LIVESTREAM,
      });
    } else if (isPrivateLiveStreamStarted) {
      buttonContent = t('button_enter_stream', {
        ns: TranslationNamespace.LIVESTREAM,
      });
    } else {
      buttonContent = t('button_pay_for_stream', {
        ns: TranslationNamespace.LIVESTREAM,
      });
    }

    return (
      <UnlockWrapper>
        <UnlockLiveStreamButton
          data-element_id={
            this.getNeedToAddvalue()
              ? ButtonId.LiveStream.CountDownToDiamondShop
              : ButtonId.LiveStream.ButtonTurnToPrivate
          }
          data-tracking_payload={this.getCurrentLiveStreamData()}
          onClick={this.handleUnlockOnClick}
          disabled={shouldShowLoadingOnUnlockButton}
          isFilled={isOnLivestreamOverlayCta}
          isPurple={isOnLivestreamOverlayCta}
        >
          {shouldShowLoadingOnUnlockButton ? (
            <UnlockButtonLoader src={LoadingImage} />
          ) : (
            <>
              <UnlockWording>{buttonContent}</UnlockWording>
              {this.renderUnlockButtonPaymentInfo()}
            </>
          )}
        </UnlockLiveStreamButton>
      </UnlockWrapper>
    );
  };
  trackUserViewOpen = () => {
    const { setModalTracking } = this.props;
    const liveStreamData = this.getCurrentLiveStreamData();
    const modalId = ModalId.LiveStream.ToPrivateCountDownPopUp;
    setModalTracking({
      modalId,
      extraProps: liveStreamData,
    });
  };
  componentDidMount() {
    const {
      isOnLivestreamOverlayCta,
      isFreeToPrivateLiveStreamPackagePopupEnabled,
      livestreamStartTime,
      popupNotificationLiveStreamPromotionTemplateId,
      isPromotionPopupOpened,
      shouldShowLivestreamCta,
    } = this.props;
    if (!isOnLivestreamOverlayCta) {
      this.trackUserViewOpen();
    }

    if (
      isFreeToPrivateLiveStreamPackagePopupEnabled &&
      livestreamStartTime &&
      popupNotificationLiveStreamPromotionTemplateId &&
      !isPromotionPopupOpened &&
      shouldShowLivestreamCta &&
      !isOnLivestreamOverlayCta
    ) {
      this.handleLivestreamPromotionPopup();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      isFreeToPrivateLiveStreamPackagePopupEnabled,
      isPromotionPopupOpened,
      livestreamStartTime,
      popupNotificationLiveStreamPromotionTemplateId,
      shouldShowLivestreamCta,
      isOnLivestreamOverlayCta,
      closePopupNotifications,
    } = this.props;

    if (
      isFreeToPrivateLiveStreamPackagePopupEnabled &&
      livestreamStartTime &&
      popupNotificationLiveStreamPromotionTemplateId &&
      !isPromotionPopupOpened &&
      prevProps.shouldShowLivestreamCta !== shouldShowLivestreamCta &&
      shouldShowLivestreamCta &&
      !isOnLivestreamOverlayCta
    ) {
      this.handleLivestreamPromotionPopup();
    }

    if (!shouldShowLivestreamCta || isOnLivestreamOverlayCta) {
      clearTimeout(this.promotionPopupTimer);
      closePopupNotifications({
        notificationTags: [LIVESTREAM_PROMOTION_POPUP_ID],
      });
    }
  }

  componentWillUnmount() {
    const { closePopupNotifications } = this.props;
    clearTimeout(this.promotionPopupTimer);
    closePopupNotifications({
      notificationTags: [LIVESTREAM_PROMOTION_POPUP_ID],
    });
  }

  render() {
    const { shouldShowLivestreamCta } = this.props;
    if (shouldShowLivestreamCta) {
      return (
        <StyledLiveStreamCountDown>
          <Container>
            <Body>{this.renderUnlockButton()}</Body>
          </Container>
        </StyledLiveStreamCountDown>
      );
    }
    return null;
  }
}

LiveStreamCountDown.propTypes = {
  isAuthed: PropTypes.bool,
  mixpanelModalId: PropTypes.string,
  streamId: PropTypes.string,
  productId: PropTypes.string,
  needAuthHandler: PropTypes.string,
  fundingId: PropTypes.string,
  streamStatus: PropTypes.string,
  privateLiveStreamStartTimestamp: PropTypes.number,
  price: PropTypes.number,
  priceDurationMinutes: PropTypes.number,
  balance: PropTypes.number,
  isPrivateStreamUnlocked: PropTypes.bool,
  isScheduledPrivateLiveStream: PropTypes.bool,
  isPrivateLiveStreamStarted: PropTypes.bool,
  isOnLivestreamOverlayCta: PropTypes.bool,
  hasBalance: PropTypes.bool,
  shouldShowLoadingOnUnlockButton: PropTypes.bool,
  hasStreamToken: PropTypes.bool,
  shouldShowPrice: PropTypes.bool,
  shouldShowLivestreamCta: PropTypes.bool,
  t: PropTypes.func.isRequired,
  login: PropTypes.func,
  addvalue: PropTypes.func,
  unlockPrivateStream: PropTypes.func,
  pushToastr: PropTypes.func,
  setModalTracking: PropTypes.func.isRequired,
  livestreamStartTime: PropTypes.number,
  isFreeToPrivateLiveStreamPackagePopupEnabled: PropTypes.bool,
  freeToPrivateLiveStreamPackagePopupThresholdSeconds: PropTypes.number,
  popupNotificationLiveStreamPromotionTemplateId: PropTypes.string,
  isPromotionPopupOpened: PropTypes.bool,
  addPopupNotification: PropTypes.func,
  closePopupNotifications: PropTypes.func,
};

LiveStreamCountDown.defaultProps = {
  isAuthed: false,
  mixpanelModalId: null,
  streamId: '',
  productId: null,
  needAuthHandler: '',
  fundingId: null,
  streamStatus: null,
  privateLiveStreamStartTimestamp: 0,
  price: null,
  priceDurationMinutes: 1,
  balance: 0,
  isPrivateStreamUnlocked: false,
  isScheduledPrivateLiveStream: false,
  isPrivateLiveStreamStarted: false,
  isOnLivestreamOverlayCta: false,
  shouldShowLoadingOnUnlockButton: false,
  hasStreamToken: false,
  shouldShowPrice: false,
  shouldShowLivestreamCta: false,
  hasBalance: false,
  login: () => null,
  addvalue: () => null,
  unlockPrivateStream: () => null,
  pushToastr: () => null,
  livestreamStartTime: undefined,
  isFreeToPrivateLiveStreamPackagePopupEnabled: false,
  freeToPrivateLiveStreamPackagePopupThresholdSeconds: 30,
  popupNotificationLiveStreamPromotionTemplateId: '',
  isPromotionPopupOpened: false,
  addPopupNotification: () => null,
  closePopupNotifications: () => null,
};

const StyledLiveStreamCountDown = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  ${media.tablet`
    max-width: 400px;
  `};
`;

const Container = styled.div`
  z-index: 1;
`;

const Body = styled.div`
  border-radius: 4px;
  overflow: hidden;
`;

const UnlockWrapper = styled.div``;

const UnlockLiveStreamButton = styled.button.attrs(
  ({ isFilled, isPurple }) => ({
    style: {
      background: isFilled
        ? isPurple
          ? 'linear-gradient(135deg, #BA39F3 0%, #5420A2 100%)'
          : color.tealBlue
        : 'rgba(100, 100, 100, 0.3)',
      color: isFilled
        ? isPurple
          ? color.neutral[100]
          : color.neutral[0]
        : color.tealBlue,
      borderWidth: `${isFilled ? 0 : 1}px`,
    },
  })
)`
  ${ResetButtonStyle};
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 100%;
  padding: 0px 12px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
`;

const UnlockWording = styled.div`
  ${TextEllipsis};
`;

const UnlockLiveStreamInfo = styled.div`
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DiamondIcon = styled.img`
  margin-left: 4px;
  margin-right: 4px;
  width: 20px;
  height: 20px;
`;

const UnlockCost = styled.div`
  font-size: 20px;
  color: #00d2be;
`;

const UnlockCostUnit = styled.span`
  margin-left: 4px;
  font-size: 12px;
  color: ${color.neutral[75]};
  line-height: 1;
`;

const UnlockButtonLoader = styled.img`
  position: absolute;
  width: 20px;
  height: 20px;
  animation: 2s infinite ${Spinning};
`;

const UnlockCostLoader = styled.img`
  margin: 0 4px;
  width: 12px;
  height: 12px;
  animation: 2s infinite ${Spinning};
`;

export default withTranslation()(LiveStreamCountDown);
